export default __webpack_public_path__ + "static/media/no_data_available.8a30056d.svg";